<template>
  <Modal v-model="modal" title="修改个人信息" footer-hide>
    <Form class="info-edit" ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem prop="email" label="邮箱">
        <Input v-model="formValidate.email" placeholder="邮箱">
          <span slot="prefix" class="proxy-icon email-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="qq" label="QQ">
        <Input v-model="formValidate.qq" placeholder="QQ">
          <span slot="prefix" class="proxy-icon companyWeb-icon"></span>
        </Input>
      </FormItem>
      <FormItem prop="address" label="联系地址">
        <Input v-model="formValidate.address" placeholder="填写省、市、区、小区、楼栋、房号">
          <span slot="prefix" class="proxy-icon companyName-icon"></span>
        </Input>
      </FormItem>
      <FormItem class="fun-form">
        <Button type="primary" :loading="loading" @click="handleSubmit('formValidate')">提交</Button>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import { isEmail } from "../../../../../lib/verification/index"
export default {
  name: "InfoEdit",
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      modal: false,
      loading: false,
      formValidate: {
        email: this.info.email,
        qq: this.info.unionQQ,
        address: this.info.address
      },
      ruleValidate: {
        email: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else if (isEmail(value)) {
              return callback(new Error('请输入正确的电子邮箱'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        qq: { message: 'qq不能为空', trigger: 'blur' },
        address: { message: '联系地址不能为空', trigger: 'blur' },
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.ChangeUnionPwd()
        } else {
          // this.$Message.error('验证失败!')
        }
      })
    },
    ChangeUnionPwd() {
      this.loading = true
      this.$store.dispatch('account/UpdateUnionInfo', this.formValidate).then(({ msg }) => {
        this.loading = false
        this.modal = false
        this.$Message.success(msg)
      }).catch(({ msg })  => {
        this.loading = false
        this.$Message.error(msg)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-edit{
  .fun-form /deep/.ivu-form-item-content{
    line-height: 1;
    text-align: right;
    a{
      display: inline-block;
      margin-bottom: 10px;
    }
  }
}
</style>